// Registers the minimal service worker in public/service-worker.js.
//
// It caches nothing - it exists so browsers offer "Install app" / "Add to
// Home Screen". Registration is production-only: in development the API lives
// on a different origin and a worker in the mix only adds confusion.

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  // The worker must be same-origin as the page to control it.
  const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  if (new URL(swUrl, window.location.href).origin !== window.location.origin) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(swUrl).catch((err) => {
      console.error('Service worker registration failed:', err);
    });
  });
}

// Escape hatch: call this instead of register() to remove the worker from
// browsers that already have it.
export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((err) => {
      console.error('Service worker unregistration failed:', err);
    });
}
